import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#5BA4D4',
      light: '#89C4E8',
      dark: '#3A7EAA',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#E87E3B',
      light: '#F0A870',
      dark: '#C45E1A',
      contrastText: '#ffffff',
    },
    success: { main: '#4CAF50' },
    warning: { main: '#FF9800' },
    error: { main: '#F44336' },
    background: {
      default: '#F5F7FA',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          textTransform: 'none',
          fontWeight: 600,
          padding: '10px 20px',
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #5BA4D4 0%, #3A7EAA 100%)',
          boxShadow: '0 4px 15px rgba(91, 164, 212, 0.4)',
          '&:hover': {
            background: 'linear-gradient(135deg, #3A7EAA 0%, #2A5E8A 100%)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 2px 20px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          borderTop: '1px solid #E0E0E0',
          height: 64,
        },
      },
    },
  },
});

export default theme;
